import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import RequirePasswordChanged from "./RequirePasswordChanged"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser") && !localStorage.getItem("token")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      return (
        <RequirePasswordChanged isAuthProtected={isAuthProtected}>
          <Layout>
            <Component {...props} />
          </Layout>
        </RequirePasswordChanged>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware;
